<div *ngIf="pageLoading1" class="loader text-center">
	<img src="../../../assets/img/loading.gif" style="width: 100px;" />
	<p style="color: black;font-weight: bolder;">Loading...</p>
</div>
<ng-container *ngIf="!pageLoading1">
	<div class="card" @fadeInOut>
		<div class="card-header">
			<h5 style="font-size: 12px !important;" class="card-title text-dark mb-0">
				Follow-up Details for {{followUpDetails?.follow_up_date}}
			</h5>
		</div>
		<div class="card-body">
			<table class="table table-bordered">
				<tbody>
					<tr>
						<td>
							<div class="row g-0">
								<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
									<label>Follow-up Date:</label>
									<p class="mb-0">{{followUpDetails?.follow_up_date}}</p>
								</div>
								<div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
									<label>Appointment Type:</label>
									<p class="mb-0">
										<img *ngIf="followUpDetails?.visit_type"
											src="../../assets/img/appt-types/{{parent.appt_type_images[followUpDetails?.visit_type?.name]}}"
											class="appt-type-img ms-1" />
										{{followUpDetails?.visit_type?.name}}
									</p>
								</div>
								<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12" *ngIf="showNonMedicalFields">
									<label>Handover:</label>
									<p class="mb-0">{{followUpDetails?.is_handover==true ? "Yes" : "No"}}</p>
								</div>
							</div>
						</td>
					</tr>
					<tr *ngIf="showOPDFields" @fadeInOut>
						<td>
							<div class="row g-0">
								<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
									<label>OPD Lab Tests:</label>
									<p class="mb-0">{{getLabtestNames()}}</p>
								</div>
							</div>
						</td>
					</tr>
					<tr *ngIf="showIPDFields" @fadeInOut>
						<td>
							<h5 class="fw-bold mb-2">Hospitalization Details:</h5>
							<div class="row g-0">
								<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
									<label>Hospitalization:</label>
									<p class="mb-0">{{getHospitalizationName()}}</p>
								</div>
								<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12"
									*ngIf="showAdmittedFields || showPreAdmittedFields || showDayCareFields">
									<label>Admission Date:</label>
									<p class="mb-0">{{followUpDetails?.admission_date}}</p>
								</div>
								<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12" *ngIf="showDischargedFields">
									<label>Discharge Date:</label>
									<p class="mb-0">{{followUpDetails?.actual_discharge_date}}</p>
								</div>
								<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12" *ngIf="showDischargedFields">
									<label>Ambulance Required:</label>
									<p class="mb-0">{{followUpDetails?.is_ambulance_needed == true ? "Yes" : "No"}}
									</p>
								</div>
								<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12"
									*ngIf="showAdmittedFields || showPreAdmittedFields || showDayCareFields">
									<label>Expected Days:</label>
									<p class="mb-0">{{followUpDetails?.expected_days}}</p>
								</div>
								<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12"
									*ngIf="showAdmittedFields || showPreAdmittedFields || showDayCareFields">
									<label>Surgery:</label>
									<p class="mb-0">{{getSurgeryStatusName()}}</p>
								</div>
								<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12"
									*ngIf="showAdmittedFields || showPreAdmittedFields || showDayCareFields">
									<label>Surgery:</label>
									<p class="mb-0">{{followUpDetails?.actual_surgery_date}}</p>
								</div>
							</div>
						</td>
					</tr>
					<tr *ngIf="showPhysiotherapyFields" @fadeInOut>
						<td>
							<h5 class="fw-bold mb-2">Physiotherapy Details:</h5>
							<div class="row g-0">
								<div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
									<label>% Imp.:</label>
									<p class="mb-0">{{followUpDetails?.physiotherapy_percentage}}</p>
								</div>
								<div class="col-lg-10 col-md-10 col-sm-12 col-xs-12">
									<label>Physiotherapy Notes:</label>
									<p class="mb-0">{{followUpDetails?.physiotherapy_notes}}</p>
								</div>
							</div>
						</td>
					</tr>
					<tr *ngIf="!showNonMedicalFields" @fadeInOut>
						<td>
							<h5 class="fw-bold mb-2">Hospital/Doctor Details:</h5>
							<div class="row g-0">
								<div class="col-lg-6 col-md-6 col-sm-12 col-xs-12" *ngIf="!showTeleConsultsFields"
									@fadeInOut>
									<label>Medical Center:</label>
									<p class="mb-0">{{followUpDetails?.dropoff_hospital?.name}}</p>
								</div>
								<div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
									<label>Doctor:</label>
									<p class="mb-0">{{followUpDetails?.opd_doctor?.name}}</p>
								</div>
							</div>
						</td>
					</tr>
					<tr>
						<td>
							<div class="row g-0">
								<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
									<label>
										Notes:
										<ng-container *ngIf="followUpDetails?.is_handover_done">
											<strong class="ms-3">
												Handover Done
												<fa-icon [icon]="['fas','check']" class="text-success"></fa-icon>
											</strong>
										</ng-container>
									</label>
									<div [innerHTML]="followUpDetails?.opd_notes || '___' | safeHtml"></div>
								</div>
							</div>
						</td>
					</tr>
					<tr *ngIf="!showNonMedicalFields" @fadeInOut>
						<td>
							<div class="row g-0">
								<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
									<label>Consultation Fees:</label>
									<p class="mb-0">{{followUpDetails?.is_payment_needed ? "Yes" : "No"}}</p>
								</div>
								<div class="col-lg-6 col-md-6 col-sm-12 col-xs-12" *ngIf="!showTeleConsultsFields"
									@fadeInOut>
									<label>Is Travel Needed:</label>
									<p class="mb-0">
										@if (!followUpDetails?.travel_needed) {
										No
										}@else if (followUpDetails?.travel_needed == 1) {
										Oneway
										}@else if (followUpDetails?.travel_needed == 2) {
										Round Trip
										}
									</p>
								</div>
								<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
									<label>Medical Notes:</label>
									<p class="mb-0">{{followUpDetails?.medical_prescription==true ? "Yes" : "No"}}
									</p>
								</div>
							</div>
						</td>
					</tr>
					<tr>
						<td>
							<div class="row g-0">
								<div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
									<label>Status 3:</label>
									<p class="mb-0">{{followUpDetails?.status3_name}}</p>
								</div>
								<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
									<label>Follow-up Status:</label>
									<p class="mb-0">{{followUpDetails?.follow_up_status?.name}}</p>
								</div>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</ng-container>
<div *ngIf="pageLoading3" class="loader text-center">
	<img src="../../../assets/img/loading.gif" style="width: 100px;" />
	<p style="color: black;font-weight: bolder;">Loading...</p>
</div>
<ng-container *ngIf="!pageLoading3">
	<div class="card" @fadeInOut>
		<div class="card-header">
			<h5 style="font-size: 12px !important;" class="card-title text-dark mb-0">
				Files
			</h5>
		</div>
		<div class="card-body">
			<table class="table table-bordered">
				<thead>
					<tr>
						<th style="width: 20% !important;">Name</th>
						<th style="width: 80% !important;">Files</th>
					</tr>
				</thead>
				<tbody>
					<ng-container *ngFor="let bill of followupFiles;let i = index;">
						<tr [ngClass]="{ 'orange': !bill.file_url || bill.file_url.length==0 }">
							<td>
								{{bill.file_name}}
							</td>
							<td>
								<ng-container *ngIf="bill.file_url">
									<div *ngFor="let file of bill.file_url;let j = index;"
										class="icon-container no-delete">
										<file-icon [file]="file"></file-icon>
									</div>
								</ng-container>
							</td>
						</tr>
					</ng-container>
				</tbody>
			</table>
		</div>
	</div>
</ng-container>